import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular';
import { sendEmailVerification } from 'firebase/auth';
import { CampaignLoyaltyProgramme, IndefiniteLoyaltyProgramme, Outlet, Shop, Story } from 'src/app/models/interfaces';
import { AlertService } from 'src/app/services/alert.service';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { AuthService } from 'src/app/services/auth.service';
import { CloudfunctriggersService } from 'src/app/services/cloudfunctriggers.service';
import { DateTimeService } from 'src/app/services/date-time.service';
import { HapticsService } from 'src/app/services/haptics.service';
import { LocationService } from 'src/app/services/location.service';
import { LoyaltyCardService } from 'src/app/services/loyalty-card.service';
import { PushNotificationsService } from 'src/app/services/pushnotifications.service';
import { StoryService } from 'src/app/services/story.service';
import { ToastServiceService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';
import { StoryViewerComponent } from '../../story-viewer/story-viewer.component';

@Component({
  selector: 'app-story-lane-card',
  templateUrl: './story-lane-card.component.html',
  styleUrls: ['./story-lane-card.component.scss'],
})
export class StoryLaneCardComponent implements OnInit {
  @Input() story: Story
  @Input() shop: Shop
  @Input() cardHeight = '50vh'
  @Output() onStorySelectEmit: EventEmitter<Story> = new EventEmitter();
  @Output() onWantsToFlip: EventEmitter<any> = new EventEmitter();
  linkClickThinking=false
  isButtonLoading
  searchLocation
  showDescription:boolean = false
  constructor(
    private hapticsService: HapticsService,
    private storyService:StoryService,
    private locationService:LocationService,
    private modalCtrl:ModalController,
    public assetLinksService: AssetlinksService,
    private ts: TranslationService,
  ) {

  }

  ngOnInit() {

  }

  async toggleShowDescription(){
   this.showDescription = !this.showDescription
  }

  async viewStory(){
    try {
      const modal = await this.modalCtrl.create({
        component: StoryViewerComponent,
        initialBreakpoint: 1,
        breakpoints: [0,1],
        handle:false,
        mode:'ios',
        componentProps:{
          shop:this.shop,
          stories:[this.story]
        }
      });
      await modal.present();
      // modal.onDidDismiss().then(shop=>{
      //   // display as now viewed
      //   this.viewed = true;
      // })
    } catch (error) {
      console.log(error);
    }
  }

  

  async openLink(story:Story) {
    if(!story.link){
      return
    }
    try {
      this.linkClickThinking = true
      try {
        await this.storyService.clickedStory(
          null,
          null,
          story,
          null
        )
      } catch (error) {
        console.log('Tried to register link click',error);
      }
      this.linkClickThinking = false;
      Browser.open({
        url:story.link
      })
    } catch (error) {
      this.linkClickThinking = false
      console.log(error);
    }
  }

  flip() {
    this.onWantsToFlip.emit()
  }



  // private async registerClick() {
  //   await this.cloudTriggers.increaseSpecialClickCount(this.story)
  // }



  async actionButtonClick() {
    this.onStorySelectEmit.emit(this.story)
        console.log('emitted from cardcomponent', this.story);
  }


}
